import { useRef } from 'react';
import HeroSection from '../../sections/HeroSection/HeroSection';
import { ThemeProvider } from 'styled-components';
import theme from '../../global/theme';
import ContactSection from '../../sections/ContactSection/ContactSection';
import CaseStudySection from '../../sections/CaseStudySection/CaseStudySection';
import { GlobalStyle } from '../../global/global';
import StyledButton from '../../components/Button/Button';
import { Box, Flex, Text, Image, Heading, Hide, Show } from '@chakra-ui/react';
import SubscriptionSection from '../../sections/SubscriptionSection/SubscriptionSection';
import { StyledHeading } from '../../sections/ContactSection/styles';
import { List, ListItem, ListIcon } from '@chakra-ui/react';
import { SubscriptionTable } from './subscriptionTable';
import { CheckIcon } from '@chakra-ui/icons';

const scrollToSection = (ref: React.RefObject<HTMLDivElement>) => {
    ref.current?.scrollIntoView({ behavior: 'smooth' });
};

interface Props {}

export default function SubscriptionsPage(props: Props) {
    const sectionAbonamentyRef = useRef(null);
    return (
        <ThemeProvider theme={theme}>
            <GlobalStyle $whiteColor />
            <HeroSection
                title="Dobierz plan abonamentowy do swoich potrzeb"
                subTitle="Naszą ideą jest maksymalizowanie sprzedaży naszych klientów, dlatego udostępniamy najlepsze rozwiązania rynkowe."
                image={{
                    url: 'https://www.idosell.com/panel/file-gate.php?id=301276&ext=.webp',
                    alt: 'Zdjęcie wyróżniające w hero - strona oferty',
                }}
                buttons={[
                    {
                        title: 'Rozpocznij sprzedaż subskrypcyjną',
                        href: '#form_section',
                        variant: 'default',
                    },
                ]}
            />

            <div className="homepage containerIdosellPages">
                <Box
                    my={{
                        base: 16,
                        md: 20,
                        xl: 24,
                    }}
                    display={'flex'}
                    flexDirection={'column'}
                    gap={{
                        base: 20,
                        md: 24,
                    }}
                >
                    <SubscriptionSection
                        buttons={[
                            {
                                title: 'Zamów sklep',
                                href: 'https://www.idosell.com/pl/order',
                                variant: 'default',
                            },
                            {
                                title: 'Umów się na spotkanie',
                                href: 'https://eu1.hubs.ly/H08swyQ0',
                                variant: 'outline',
                            },
                        ]}
                    />

                    <Box>
                        <StyledHeading>
                            IdoSell oferuje bogaty wybór planów abonamentowych i sklepy dostosowane
                            do indywidualnych wymagań.
                        </StyledHeading>
                        <Flex
                            mt={7}
                            flexWrap={'wrap'}
                            alignItems="center"
                            justifyContent={{
                                base: 'center',
                                md: 'space-between',
                            }}
                            position={'relative'}
                            _before={{
                                base: {
                                    content: '""',
                                    position: 'absolute',
                                    height: '100%',
                                    top: 0,
                                    width: '100vw',
                                    marginLeft: '50%',
                                    left: '-50vw',
                                    zIndex: -2,
                                    backgroundColor: '#1AAC7A', // Replace with your theme color reference
                                },
                                lg: {
                                    display: 'none',
                                },
                            }}
                        >
                            <Flex
                                id="plany"
                                width={{
                                    base: '100%',
                                    md: '46%',
                                }}
                                direction={'column'}
                                py={{
                                    base: 10,
                                    md: 14,
                                }}
                                px={{
                                    base: 2,
                                    md: 12,
                                }}
                                background={'#1AAC7A'}
                                position={'relative'}
                            >
                                <Box
                                    minH={{
                                        md: '700px',
                                    }}
                                    mb={3}
                                >
                                    <Image
                                        m={'auto'}
                                        src="https://www.idosell.com/panel/file-gate.php?id=301723&ext=.jpg"
                                    />
                                    <Text
                                        fontWeight={'600'}
                                        fontSize={'2xl'}
                                        color={'white'}
                                        mt={6}
                                    >
                                        Dopasowany abonament IdoSell
                                    </Text>
                                    <Text my={6}>
                                        Wybierz jeden z pięciu planów abonamentowych IdoSell.
                                    </Text>
                                    <List spacing={3}>
                                        <ListItem display={'flex'}>
                                            <ListIcon mt={1} mr={4} as={CheckIcon} />
                                            <Text color={'white'}>
                                                Dla każdego rozmiaru biznesu
                                            </Text>
                                        </ListItem>
                                        <ListItem display={'flex'}>
                                            <ListIcon mt={1} mr={4} as={CheckIcon} />
                                            <Text color={'white'}>
                                                Setki gotowych funkcjonalności i integracji
                                                dostępnych w każdym planie
                                            </Text>
                                        </ListItem>
                                    </List>
                                </Box>
                                <StyledButton
                                    onClick={() => scrollToSection(sectionAbonamentyRef)}
                                    style="default"
                                    target="_blank"
                                >
                                    Poznaj nasze abonamenty
                                </StyledButton>
                            </Flex>

                            <Box
                                my={2}
                                display={'flex'}
                                justifyContent={'center'}
                                w={{
                                    base: '100%',
                                    md: 'auto',
                                }}
                                position={'relative'}
                                sx={{
                                    _before: {
                                        content: ['""', null, 'none'], // Note: Double quotes inside single quotes
                                        width: '100%',
                                        height: '2px',
                                        position: 'absolute',
                                        left: '0',
                                        top: '6px',
                                        borderBottom: '3px dotted white',
                                        borderLeftStyle: 'dotted',
                                        borderRightStyle: 'dotted',
                                        borderLeftColor: 'white',
                                        borderRightColor: 'white',
                                    },
                                }}
                            >
                                <Show above="md">
                                    {' '}
                                    <svg
                                        width="32"
                                        height="32"
                                        viewBox="0 0 32 32"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M17.6221 14.3779V3H14.3779V14.3779H3V17.6221H14.3779V29H17.6221V17.6221H29V14.3779H17.6221Z"
                                            fill="#171717"
                                        />
                                    </svg>
                                </Show>
                                <Show below="md">
                                    <Box zIndex={2} backgroundColor={'#1AAC7A'} px={2}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="14"
                                            height="15"
                                            viewBox="0 0 14 15"
                                            fill="none"
                                        >
                                            <path
                                                fill-rule="evenodd"
                                                clip-rule="evenodd"
                                                d="M8.75 0.710938H5.25V5.96094H0V9.46094H5.25V14.7109H8.75V9.46094H14V5.96094H8.75V0.710938Z"
                                                fill="white"
                                            />
                                        </svg>
                                    </Box>
                                </Show>
                            </Box>

                            <Flex
                                width={{
                                    base: '100%',
                                    md: '46%',
                                }}
                                direction={'column'}
                                py={{
                                    base: 10,
                                    md: 14,
                                }}
                                px={{
                                    base: 2,
                                    md: 12,
                                }}
                                background={'#1AAC7A'}
                            >
                                <Box
                                    minH={{
                                        md: '700px',
                                    }}
                                    mb={3}
                                >
                                    <Image
                                        m={'auto'}
                                        src="https://www.idosell.com/panel/file-gate.php?id=301724&ext=.jpg"
                                    />
                                    <Text
                                        fontWeight={'600'}
                                        fontSize={'2xl'}
                                        color={'white'}
                                        mt={6}
                                    >
                                        Wdrożenie sklepu na miarę
                                    </Text>
                                    <Text my={6}>
                                        W IdoSell możesz wdrożyć sklep sam lub wybrać jeden z
                                        czterech pakietów wdrożeniowych, dzięki którym nasi eksperci
                                        stworzą dla ciebie sklep skorjony na miarę!
                                    </Text>
                                    <List spacing={3}>
                                        <ListItem display={'flex'}>
                                            <ListIcon mt={1} mr={4} as={CheckIcon} />
                                            <Text color={'white'}>
                                                Wdrożenie szablonu sklepu zgodnie z twoimi
                                                wytycznymi
                                            </Text>
                                        </ListItem>
                                        <ListItem display={'flex'}>
                                            <ListIcon mt={1} mr={4} as={CheckIcon} />
                                            <Text color={'white'}>
                                                Elastyczna możliwość zlecenia dodatkowych prac
                                                deweloperskich
                                            </Text>
                                        </ListItem>
                                    </List>
                                </Box>
                                <StyledButton
                                    href="https://www.idosell.com/pl/pakiety-wdrozeniowe/"
                                    style="default"
                                    target="_blank"
                                >
                                    Poznaj pakiety wdrożeniowe
                                </StyledButton>
                            </Flex>
                        </Flex>
                    </Box>

                    <Box ref={sectionAbonamentyRef}>
                        <SubscriptionTable />
                    </Box>

                    <CaseStudySection
                        title="Zaufało nam tysiące sprzedawców"
                        text="Zobacz inspirujące historie sklepów, które wybrały IdoSell i osiągnęły sukces w sprzedaży online.
Sprawdź, jak dołączyły do grona profesjonalistów i zaczęły sprzedawać więcej."
                        casestudies={[
                            {
                                image: {
                                    url: 'https://www.idosell.com/panel/file-gate.php?id=279666&ext=.jpeg',
                                    alt: 'Zdjęcie wyróżniające Ministerstwo Dobrego Mydła',
                                },
                                // hastags: '#AllinOne',
                                title: 'Decyzja padła na IdoSell, który na ten moment dostarcza nam wszystkich potrzebnych funkcjonalności.',
                                link: {
                                    label: 'Ministerstwo Dobrego Mydła',
                                    href: 'https://www.idosell.com/pl/historie-klientow-idosell/ministerstwo-dobrego-mydla/',
                                    target: '_blank',
                                },
                            },
                            {
                                image: {
                                    url: 'https://www.idosell.com/panel/file-gate.php?id=279665&ext=.jpeg',
                                    alt: 'Zdjęcie wyróżniające Flamqa',
                                },
                                title: 'Dobra świeca powinna być niczym dobre perfumy.',
                                link: {
                                    label: 'Flamqa',
                                    href: 'https://www.idosell.com/pl/historie-klientow-idosell/flamqa/',
                                    target: '_blank',
                                },
                            },
                            {
                                image: {
                                    url: 'https://www.idosell.com/panel/file-gate.php?id=287972&ext=.jpg',
                                    alt: 'Zdjęcie wyróżniające zielona esencja',
                                },
                                title: 'Własna marka w e-commerce oparta o wartości i platformę IdoSell',
                                link: {
                                    label: 'Zielona Esencja',
                                    href: 'https://www.idosell.com/pl/historie-klientow-idosell/zielona-esencja/',
                                    target: '_blank',
                                },
                            },
                        ]}
                        bgColor="white"
                    />
                    <ContactSection id="form_section" />
                </Box>
            </div>
        </ThemeProvider>
    );
}
